import { ShipmentType } from "@api/graphql/generated/generated-types";

export const shipmentTypeArray = enumToArrayOfObjects(ShipmentType).filter(
  (item) => item.label !== ShipmentType.SingleStop
);

// Full list including SingleStop — used only to resolve the currently selected
// value for display. SingleStop must never appear in `shipmentTypeArray` (the
// selectable options), but a SINGLE_STOP order still needs its value rendered.
const allShipmentTypeOptions = enumToArrayOfObjects(ShipmentType);

export function enumToArrayOfObjects<T extends Record<string, string>>(
  enumeration: T
): { id: string; label: string }[] {
  return Object.entries(enumeration).map(([id, label]) => ({ id, label }));
}

export function returnObjectForSelectValue(getValues): any[] {
  const selectValue = getValues(`type`);
  if (typeof selectValue === "string") {
    const shipmentsTypeFound = allShipmentTypeOptions.find(
      (item) => item.label === selectValue
    );
    if (shipmentsTypeFound) {
      return [shipmentsTypeFound];
    }
  }
  if (selectValue) {
    return selectValue;
  }
  return [];
}

// Centralized rule for when the Stops dropdown is locked in the edit forms.
// A single-stop order's type must not be changed (switching it to a multi-stop
// type breaks order generation), so the dropdown is disabled. Extend this
// predicate as more non-editable shipment types are added.
export function isStopsDropdownDisabled(
  shipmentType: ShipmentType | string | undefined
): boolean {
  return shipmentType === ShipmentType.SingleStop;
}
